/** @jsxImportSource @emotion/react */
import {
  Box,
  IconButton,
  inputBaseClasses,
  outlinedInputClasses,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import MailIcon from "./icons/MailIcon";
import MessageIcon from "./icons/MessageIcon";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import { l_footer } from "../locales";

const url =
  "https://mabiloft.us19.list-manage.com/subscribe/post?u=8e0b1d162cb0ff02e2cdac299&amp;id=00f4e4a761";

const CustomForm = ({
  status,
  message,
  onValidated,
}: {
  status: "error" | "success" | "sending" | null;
  message: string | Error | null;
  onValidated: (formData: any) => void;
}) => {
  const [mail, setMail] = useState("");

  function handleSubmit() {
    const email = mail;
    setMail("");
    onValidated({
      EMAIL: email,
      NAME: "",
    });
  }

  return (
    <>
      {status !== "success" && (
        <Box
          sx={{
            marginTop: "12px",
            marginBottom: "24px",
            height: "60px",
            position: "relative",
          }}
        >
          <TextField
            placeholder={l_footer("mailSection.placeholder")}
            value={mail}
            onChange={(e) => {
              setMail(e.target.value);
            }}
            sx={{
              width: "100%",
              padding: 0,

              border: "1px solid transparent",
              borderRadius: "30px",
              backgroundColor: "rgba(255, 255, 255, 0.06)",
              "& .Mui-focused": {
                borderColor: "rgb(255, 255, 255)",
                borderRadius: "30px",
              },
              [`& .${inputBaseClasses.input}`]: {
                opacity: 1,
                color: "#fff",
                "::placeholder": { color: "#ffffff" },
                margin: "0px 12px",
                padding: 0,
              },
              [`& .${inputBaseClasses.root}`]: {
                padding: "8px 12px",
                "&.Mui-focused": {
                  [`& .${outlinedInputClasses.notchedOutline}`]: {
                    border: "1px solid rgba(255, 255, 255, .88)",
                  },
                },
              },
              [`& .${outlinedInputClasses.notchedOutline}`]: {
                border: 0,
              },
            }}
            InputProps={{
              startAdornment: <MailIcon />,
              endAdornment: (
                <IconButton
                  sx={{
                    ":hover": { backgroundColor: "#FFFFFF88" },
                    ":active": { backgroundColor: "#FFFFFF88" },
                  }}
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  <MessageIcon />
                </IconButton>
              ),
            }}
          />
          {status === "sending" && (
            <Typography
              sx={{
                fontSize: "12px",
                lineHeight: "20px",
                color: "#ffffff",
                position: "absolute",
              }}
            >
              Loading...
            </Typography>
          )}
          {status === "error" && (
            <Typography
              sx={{
                fontSize: "12px",
                lineHeight: "20px",
                color: "#ffffff",
                position: "absolute",
                marginTop: "4px",
              }}
            >
              {l_footer("mailSection.errorMsg")}
            </Typography>
          )}
        </Box>
      )}
      {status === "success" && (
        <Box
          sx={{
            marginTop: "28px",
            marginBottom: "24px",
            height: "60px",
            position: "relative",
          }}
        >
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 800,
              color: "#ffffff",
              marginBottom: "8px",
            }}
          >
            {l_footer("mailSection.successMsg1")}
          </Typography>
          <Typography sx={{ fontSize: "16px", color: "#ffffff88" }}>
            {l_footer("mailSection.successMsg2")}
          </Typography>
        </Box>
      )}
    </>
  );
};

const MailSection = () => {
  return (
    <Box>
      <Box sx={{}}>
        <Typography
          sx={{
            fontSize: {
              md: "14px",
              xs: "14px",
            },
            marginBottom: "12px",
            textTransform: "uppercase",
            color: "rgba(255, 255, 255, 0.74)",
          }}
        >
          {l_footer("mailSection.title")}
        </Typography>
        <Typography
          sx={{
            fontSize: {
              md: "16px",
              xs: "14px",
              color: "rgba(255, 255, 255)",
              marginBottom: "12px",
            },
          }}
        >
          {l_footer("mailSection.description")}
        </Typography>
      </Box>

      <MailchimpSubscribe
        url={url}
        render={({ subscribe, status, message }) => (
          <CustomForm
            status={status}
            message={message}
            onValidated={(formData) => subscribe(formData)}
          />
        )}
      />

      <Typography
        sx={{
          fontSize: "12px",
          lineHeight: "20px",
          color: "rgba(255, 255, 255, 0.64)",
        }}
      >
        {l_footer("mailSection.privacyConsent1")}
        <a
          href="https://mabiloft.com/it/privacy/"
          target="_blank"
          rel="noreferrer noopener"
          css={{
            color: "rgba(255, 255, 255, 0.64)",
            textDecoration: "underline",
            ":hover": { cursor: "pointer", textDecoration: "none" },
          }}
        >
          privacy policy
        </a>{" "}
        {l_footer("mailSection.privacyConsent2")}
      </Typography>
    </Box>
  );
};
export default MailSection;
